import { render, staticRenderFns } from "./professionalIntro.vue?vue&type=template&id=3e31408a&scoped=true&"
import script from "./professionalIntro.vue?vue&type=script&lang=js&"
export * from "./professionalIntro.vue?vue&type=script&lang=js&"
import style0 from "./professionalIntro.vue?vue&type=style&index=0&id=3e31408a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e31408a",
  null
  
)

export default component.exports